import styled from 'styled-components';

interface ButtonProps {
	$color?: string;
	$size?: string;
}

export const Button = styled.div<ButtonProps>`
	max-width: 34px;
	min-width: ${props => props.$size || '21px'};
	min-height: ${props => props.$size || '21px'};
	border-radius: 100%;
	background: ${props => props.$color || '#FBA351'};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	color: white;
`;
